import {Pipe, PipeTransform} from '@angular/core';
import {TableService} from 'app/shared/service/table.service';
import {DefinitionParametreNombre} from 'app/shared/model/definition-parametre-nombre';

/**
 * Renvoie le step d'un input numérique en fonction de la définition d'un paramètre.
 */
@Pipe({name: 'columnInputNumberStep'})
export class ColumnInputNumberStepPipe implements PipeTransform {

    constructor(public tableService: TableService) {
    }

    transform(param: DefinitionParametreNombre) {
        return this.tableService.getStepFromParameterNombre(param);
    }
}
